(function ($, window) {

  function getPercent(value, min, max) {
    return ((value - min) / (max - min)) * 100;
  }

  function initRangeSliders(context = document) {
    $('.range-slider', context).each(function () {
      const $slider = $(this);

      const $rangeInputs  = $slider.find('.range-slider__range');
      const $numberInputs = $slider.find('.range-slider__number');
      const $progress     = $slider.find('.range-slider__progress');

      const $minRange = $slider.find('.range-slider__range--min');
      const $maxRange = $slider.find('.range-slider__range--max');
      const $minInput = $slider.find('.range-slider__number--min');
      const $maxInput = $slider.find('.range-slider__number--max');

      const minVal = parseInt($minRange.val(), 10);
      const maxVal = parseInt($maxRange.val(), 10);
      const min = parseInt($minRange.attr('min'), 10);
      const max = parseInt($maxRange.attr('max'), 10);

        $progress.css({
        left:  getPercent(minVal, min, max) + '%',
        right: 100 - getPercent(maxVal, min, max) + '%'
      });

      const priceGap = parseInt($slider.data('gap'), 10) || 10;

      // prevent duplicate bindings
      $numberInputs.off('.rangeSlider');
      $rangeInputs.off('.rangeSlider');

      $numberInputs.on('input.rangeSlider', function () {
        let minVal = parseInt($minInput.val(), 10);
        let maxVal = parseInt($maxInput.val(), 10);
        const min = parseInt($minRange.attr('min'), 10);
        const max = parseInt($maxRange.attr('max'), 10);

        if (maxVal - minVal < priceGap) return;

        if ($(this).hasClass('range-slider__number--min')) {
          $minRange.val(minVal);
        } else {
          $maxRange.val(maxVal);
        }

        $progress.css({
          left:  getPercent(minVal, min, max) + '%',
          right: 100 - getPercent(maxVal, min, max) + '%'
        });
      });

      $rangeInputs.on('input.rangeSlider', function () {
        let minVal = parseInt($minRange.val(), 10);
        let maxVal = parseInt($maxRange.val(), 10);
        const min = parseInt($minRange.attr('min'), 10);
        const max = parseInt($maxRange.attr('max'), 10);

        if (maxVal - minVal < priceGap) {
          if ($(this).is($minRange)) {
            minVal = maxVal - priceGap;
            $minRange.val(minVal);
          } else {
            maxVal = minVal + priceGap;
            $maxRange.val(maxVal);
          }
        }

        $minInput.val(minVal);
        $maxInput.val(maxVal);

        $progress.css({
          left:  getPercent(minVal, min, max) + '%',
          right: 100 - getPercent(maxVal, min, max) + '%'
        });
      });
    });
  }

  // expose globally
  window.initRangeSliders = initRangeSliders;

  // initial load
  $(function () {
    initRangeSliders();
  });

})(jQuery, window);
